import { validateLength, validateNumber } from 'simple-valley'

export default function yearValidator(v) {
  if (!v.data.year) return v

  v = validateNumber(v, 'year')
  v.data.yearString = v.data.year.toString()
  v = validateLength(v, 'yearString', { min: 4, max: 4, message: 'Year should be 4 digits.' })
  delete v.data.yearString

  return v
}